import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/underConstruction/Underconstruction.min.css';

const underConstructImg = '/images/underConstruction.svg'

const UnderConstruction = () => {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className="under-construction-container d-flex flex-column justify-content-center align-items-center">
            <div className='py-4 section-separator w-100 d-flex justify-content-center'>
                <img src={underConstructImg} alt='Under construction'loadimg='lazy'/>
            </div>
            <div className='accent d-flex align-items-center justify-content-center p-4 w-100 section-separator'>
                <p className='display-3 text-uppercase text-justify px-5 bg-transp mb-0'>
                    esta página está a ser construída pedimos desculpa
                </p>
            </div>
            <div className='pt-5'>
                <button type='button' className='main-btn fw-bold' onClick={handleClick}>Voltar Atrás</button>
            </div>
        </div>
    )
}

export default UnderConstruction;